import React, { Component } from 'react';
import Card from '../../atoms/Card';
import ContractAccuracyBadge from '../../atoms/ContractAccuracyBadge';
import ActionTag from '../../atoms/ActionTag';
import { ACTION_TAG, ACTION_TIME_TYPE, DAY_TYPE, formatDate } from '../../../Common';
import { NegotiationResultActionInfo } from '../../../external/NegotiationListApi';
import { MasterInfoState } from '../../../redux/reducers/MasterInfoReducer';

interface ProductCardItemProps {
  commodityCategory: string;
  commodityContract: string;
  negotiationStatus: string;
  contractAccuracy: string;
  commodityBrand: string;
  negotiationResultActionInfo?: NegotiationResultActionInfo[];
  masterInfo: MasterInfoState;
  today: string;
}

export default class ProductCardItem extends Component<ProductCardItemProps, any> {
  constructor(props: ProductCardItemProps) {
    super(props);
  }

  render() {
    const {
      commodityCategory,
      commodityContract,
      negotiationStatus,
      contractAccuracy,
      commodityBrand,
      negotiationResultActionInfo,
      masterInfo,
      today,
    } = this.props;
    const actionTimeFromHourKItem = masterInfo.pcmCodeDivisionList.find((item) => item.pcmCdDivision === '0161');

    const formatActionTimeFromHourKItem = (actionTimeFrom: string): string => {
      let actionTimeFromC = '';
      if (actionTimeFrom !== 'null') {
        actionTimeFromC = actionTimeFrom;
      } else {
        return '';
      }
      const resultActionTimeFrom = actionTimeFromHourKItem?.pcmCodeList.find((item) => item.pcmCd === actionTimeFromC.substring(0, 2));
      return resultActionTimeFrom === undefined ? '' : resultActionTimeFrom.pcmCdNm + '';
    };

    const dateTimeFromToDisplay = (actionType: string, actionTimeType?: string, timeFrom?: string, timeTo?: string): string => {
      let timeDisp = '';
      if (actionTimeType && actionTimeType !== '01') {
        // アクション予定時間区分が時間指定以外の場合
        // AM/PMの表示はアクション区分に関わらず共通表示なので最初に判定
        timeDisp = ACTION_TIME_TYPE[actionTimeType].name;
      } else if (actionType === '03' || actionType === '02') {
        // アクション区分が架電または受電待ちの場合
        let timeFromDisp = '';
        let timeToDisp = '';
        timeFromDisp = formatActionTimeFromHourKItem(timeFrom + '');
        timeToDisp = formatActionTimeFromHourKItem(timeTo + '');
        timeDisp = timeFromToFormat(timeFromDisp, timeToDisp);
      } else if (actionType === '01') {
        // アクション区分が来店の場合
        timeDisp = timeFromToFormat(timeFrom, timeTo);
      }
      return timeDisp;
    };

    const timeFromToFormat = (timeFrom?: string, timeTo?: string): string => {
      let timeFormat = '';
      if (!timeFrom && !timeTo) {
        timeFormat = '時刻選択なし';
      } else if (timeFrom && timeTo) {
        timeFormat = timeFrom + '～' + timeTo;
      } else if (timeFrom && !timeTo) {
        timeFormat = timeFrom + '～時刻選択なし';
      } else {
        timeFormat = '時刻選択なし～' + timeTo;
      }
      return timeFormat;
    };

    return (
      <div data-testid-e2e='searchResultItem-productCard'>
        {negotiationStatus === '商談終了' ? (
          <Card className='u-mt8 u-bg' data-testid-e2e='productCard-doneNegotiation'>
            <Card.Header
              isNegotiationList
              right={
                <>
                  <div
                    className='u-text-middle'
                    data-testid='serch-result-product-card-item--negotiation-statsu'
                    data-testid-e2e='searchResultProductCardItem-negotiationStatusName'>
                    {negotiationStatus}
                  </div>
                </>
              }>
              <div>
                {commodityBrand && <span data-testid='serch-result-product-card-item--product-brand'>{'（' + commodityBrand + '）'}</span>}
                <span data-testid='serch-result-product-card-item--product-name' data-testid-e2e='commodityCategoryContractTypeName'>
                  {commodityCategory} - {commodityContract}
                </span>
              </div>
            </Card.Header>
            <Card.Content>
              <div data-testid-e2e='searchResultProductCardItem-actionItem'>
                <p className='u-text-disabled u-text-m'>アクション予定がありません</p>
              </div>
            </Card.Content>
          </Card>
        ) : (
          <Card isBordered className='u-mt8' data-testid-e2e='productCard-doingNegotiation'>
            <Card.Header
              isNegotiationList
              right={
                <>
                  <div
                    className='u-text-middle'
                    data-testid='serch-result-product-card-item--negotiation-statsu'
                    data-testid-e2e='searchResultProductCardItem-negotiationStatusName'>
                    {negotiationStatus ? negotiationStatus : '-'}
                  </div>
                  <ContractAccuracyBadge contractAccuracy={contractAccuracy} />
                </>
              }>
              <div>
                {commodityBrand && <span data-testid='serch-result-product-card-item--product-brand'>{'（' + commodityBrand + '）'}</span>}
                <span data-testid='serch-result-product-card-item--product-name' data-testid-e2e='commodityCategoryContractTypeName'>
                  {commodityCategory} - {commodityContract}
                </span>
              </div>
            </Card.Header>
            <Card.Content>
              <div data-testid-e2e='searchResultProductCardItem-actionItem'>
                {/* アクションがない場合 */}
                {((negotiationResultActionInfo && negotiationResultActionInfo.filter((v) => ACTION_TAG[v.actionType]).length === 0) ||
                  negotiationResultActionInfo === undefined) && <p className='u-text-disabled u-text-m'>アクション予定がありません</p>}
                {/* アクションがある場合 */}
                {negotiationResultActionInfo &&
                  negotiationResultActionInfo
                    .filter((v) => ACTION_TAG[v.actionType])
                    .map((actionInfo) => {
                      return (
                        <ActionTag
                          actionType={ACTION_TAG[actionInfo.actionType].icon}
                          actionTypeName={ACTION_TAG[actionInfo.actionType].name}
                          actionDate={
                            !actionInfo.dayType || actionInfo.dayType === '3'
                              ? actionInfo.actionDate
                                ? formatDate(actionInfo.actionDate, 'YYYY-MM-DD', 'YYYY/MM/DD')
                                : '日付設定なし'
                              : DAY_TYPE[actionInfo.dayType].name
                          }
                          actionTimeFrom={dateTimeFromToDisplay(
                            actionInfo.actionType,
                            actionInfo.actionTimeType,
                            actionInfo.actionTimeFrom,
                            actionInfo.actionTimeTo,
                          )}
                          tagName={actionInfo.externalSystemType && actionInfo.externalSystemType === '01' ? '来店予約あり' : undefined}
                          today={today}
                        />
                      );
                    })}
              </div>
            </Card.Content>
          </Card>
        )}
      </div>
    );
  }
}
